import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HardCodeService {
  public estados = [
    { label: 'Selecionar', sigla: null },
    { label: 'Acre', sigla: 'AC' },
    { label: 'Alagoas', sigla: 'AL' },
    { label: 'Amapá', sigla: 'AP' },
    { label: 'Amazonas', sigla: 'AM' },
    { label: 'Bahia', sigla: 'BA' },
    { label: 'Ceará', sigla: 'CE' },
    { label: 'Distrito Federal', sigla: 'DF' },
    { label: 'Espírito Santo', sigla: 'ES' },
    { label: 'Goiás', sigla: 'GO' },
    { label: 'Maranhão', sigla: 'MA' },
    { label: 'Mato Grosso', sigla: 'MT' },
    { label: 'Mato Grosso do Sul', sigla: 'MS' },
    { label: 'Minas Gerais', sigla: 'MG' },
    { label: 'Pará', sigla: 'PA' },
    { label: 'Paraíba', sigla: 'PB' },
    { label: 'Paraná', sigla: 'PR' },
    { label: 'Pernambuco', sigla: 'PE' },
    { label: 'Piauí', sigla: 'PI' },
    { label: 'Rio de Janeiro', sigla: 'RJ' },
    { label: 'Rio Grande do Norte', sigla: 'RN' },
    { label: 'Rio Grande do Sul', sigla: 'RS' },
    { label: 'Rondônia', sigla: 'RO' },
    { label: 'Roraima', sigla: 'RR' },
    { label: 'Santa Catarina', sigla: 'SC' },
    { label: 'São Paulo', sigla: 'SP' },
    { label: 'Sergipe', sigla: 'SE' },
    { label: 'Tocantins', sigla: 'TO' },
  ];

  public roles = [
    { label: 'Selecionar', role: null },
    { label: 'Administrador', role: 'SEVI_ADM[*]' },
    { label: 'Eleitor', role: 'SEVI_ELEITOR[*]' },
  ];

  public rolesEdit = [
    { label: 'Selecionar', role: null },
    { label: 'Administrador', role: 'SEVI_ADM[*]' },
    { label: 'Sindicato', role: 'SEVI_SIND[*]' },
    { label: 'Eleitor', role: 'SEVI_ELEITOR[*]' },
  ];
}
